import * as ActionTypes from '../actionTypes';

export const operations = (
  state = {
    allowedOperations: [],
    currentOperation: ''
  },
  action,
) => {
  switch (action.type) {
    case ActionTypes.UPDATE_OPERATIONS:
      localStorage.setItem('operations', JSON.stringify({
        ...state,
        ...action.payload
      }));
      return {
        ...state,
        ...action.payload
      };
    default:
      const operations = JSON.parse(localStorage.getItem('operations'));
      if (operations) {
        return {
          ...state,
          ...operations
        };
      }
      return state;
  }
};
